declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../../services/spinner.service';
import { AppData } from '../../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, GuardianInfoRequest, SaveGuardianInfoRequest } from '../../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../../models/actor/actor';
import { ActorService } from '../../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../../models/master/mastermodel';
import { FDService } from '../../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';

@Component({
  selector: 'ngbeditguardian',
  templateUrl: './editguardian.modal.html',
  styleUrls: ['./editguardian.modal.scss']
})

export class NgbEditGuardianModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() CurrentActorEditGuardianInfoRequest: SaveGuardianInfoRequest;
  @Input() ServiceCode: number;
  //@Input() ActorCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  //CurrentActorEditGuardainInfoRequest: GuardianInfoRequest;
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {

    this.ShowService = false;
    //this.CurrentActorEditGuardainInfoRequest = new GuardianInfoRequest();
    //this.CurrentActorEditGuardainInfoRequest.ActorCode = this.ActorCode;

    //this.CurrentActorEditGuardainInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //alert(this.CurrentActorEditGuardianInfoRequest.RelationShip);
    this.LoadRegistries();


  }



  //BranchMapData: ServiceBranchMapByServiceCodeController[];
  //BranchMapRequest: ServiceBranchMapByServiceCodeRequest;
  //this.pdata = this.CurrentCustomCodeValuesController;
  LoadRegistries() {
    this.stopRefreshing();
  }



  onSubmit() {

    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SaveActorGuardianInfo(this.CurrentActorEditGuardianInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }





}
